import { render, staticRenderFns } from "./AutoPostBoostingTable.vue?vue&type=template&id=4922c9b5&scoped=true&"
import script from "./AutoPostBoostingTable.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingTable.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingTable.vue?vue&type=style&index=0&id=4922c9b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922c9b5",
  null
  
)

export default component.exports